import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem("adminToken");

  // ❌ If not logged in, redirect to admin login
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  // ✅ If logged in, allow access
  return children;
}
